export default "__VITE_ASSET__BwVtxiGN__"